module.exports = __webpack_public_path__ + "static/media/chart.75561531.svg";